// extracted by mini-css-extract-plugin
export var equalColumn = "_ez-0";